module.exports = __webpack_public_path__ + "static/media/interaction-rates.7f579680.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/interaction-rates.png
// module id = 450
// module chunks = 0